import { useCallback } from 'react';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Button from '@zenbusiness/zui/Button';

import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import StatementsModal from '#client/components/StatementsModal';
import useDisableDashboardContext from '#client/hooks/useDisableDashboardContext';
import useModalContext from '#client/hooks/useModalContext';

export default function StatementsButton() {
  const { isDisable } = useDisableDashboardContext();
  const { openModal } = useModalContext();

  /**
   * Tracking Details: Tracking added to statements button
   * Question: How many user click the statements button?
   */
  const trackStatementPressed = useButtonPressedCallback({
    elementName: 'statements_button',
    elementText: 'Statements',
    appPageName: 'active_banking_dashboard'
  });

  const handleClick = useCallback(() => {
    trackStatementPressed();
    openModal({
      component: StatementsModal
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  return (
    <Button
      disabled={isDisable}
      icon={<DescriptionOutlinedIcon />}
      onClick={handleClick}
      size="small"
      variant="outlined"
    >
      Statements
    </Button>
  );
}
